import styled from "styled-components"
import { mobile, mobilePortrait, tablet } from "../../Responsive"

export const Container = styled.div`
    background-color: ${({ theme }) => theme.body};
`

export const Wrapper = styled.div`
    margin-top: 100px;
    min-height: 85vh;

    ${tablet({ marginTop: "80px"})}
    ${mobile({ marginTop: "60px", padding: "10px"})}
    ${mobilePortrait({ marginTop: "40px"})}
`

export const Title = styled.h1`
    margin: 20px;

    ${mobile({ margin: "10px" })}
`